









// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import EditDrawer from '@/components/shared/EditDrawer.vue'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import { getDefaultAloFamily, AloFamily } from '@/models/alo/AloFamily';
import { AloNewCarte, getDefaultAloNewCarte } from '@/models/alo/AloNewCarte';
import { directPayloadQuery } from '@/utils/api';
import apiFamily from '@/api/family'

@Component({
  name: 'EditCarte',    
  components:{EditDrawer}, 
})
export default class EditCarte extends Vue {
  
  private showDrawer = false
  private saving = false
  private carteStatus = ""
  private carte = null
  private family:AloFamily = getDefaultAloFamily()
  private prolongation = 0

    
  edit(item:AloFamily,carte:any) {
    this.$store.myActions.ADM_FAMILY_RESET_STATUS()
    this.showDrawer = true    
    this.carte = carte        
    this.family = item
  }
  

  get isDirty() {
    return this.prolongation != 0
  }

  get familyStatus() {
    return this.$store.myGetters.familyStatus        
  }

  saveData() {    
    if ((this.$refs.editForm as HTMLFormElement).validate()) {
      this.saving = true
      //@ts-ignore
      const newCarte = {...getDefaultAloNewCarte(),id:this.carte.id,validiteM:this.carte.forfait.cftValiditeM + this.prolongation}
      directPayloadQuery(apiFamily.updateCarte,{famId:this.family.id,carte:newCarte}).then((result)=>{
        //requete de nouveau les données de la famille      
        this.$store.myActions.ADM_FAMILY_DETAIL_REQUEST(this.family.id).finally(()=>{
          this.showDrawer = false
        })
      }).finally(()=>{        
        this.saving = false    
      })     

    } 
  }

}
